import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@apps/web/components/ui/dialog';
import { Markdown } from '@apps/web/components/ui/markdown';
import { useAgentPlaybookItems } from '@apps/web/swr_data_fetching/data_fetching_hooks';

/**
 * The playbook rule a note wrote, opened in place.
 *
 * Mirrors the admin notes page, which shows the rule in a dialog rather than
 * navigating: leaving the panel to read one rule costs the conversation the
 * reader is in, and the rule is a paragraph.
 */
export function PlaybookRecordModal({
    organizationId,
    playbookId,
    onClose,
}: {
    readonly organizationId: string;
    readonly playbookId: string;
    readonly onClose: () => void;
}) {
    const { data, isLoading } = useAgentPlaybookItems(organizationId, {
        reason: 'phoebe-chat-learned-playbook-modal',
    });
    const playbook = data?.items.find((item) => item.id === playbookId) ?? null;

    return (
        <Dialog
            open={true}
            onOpenChange={(next) => {
                if (!next) {
                    onClose();
                }
            }}
        >
            <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-xl">
                <DialogHeader>
                    <DialogTitle>
                        {playbook?.title ?? 'Playbook rule'}
                    </DialogTitle>
                    <DialogDescription>
                        {playbook?.trigger_description ??
                            'The playbook rule created from this note.'}
                    </DialogDescription>
                </DialogHeader>
                {isLoading ? (
                    <p role="status" className="text-muted-foreground text-sm">
                        Loading…
                    </p>
                ) : playbook ? (
                    <Markdown>{playbook.body_markdown}</Markdown>
                ) : (
                    <p className="text-muted-foreground text-sm">
                        This rule is no longer in the playbook.
                    </p>
                )}
            </DialogContent>
        </Dialog>
    );
}
